import { SelectOption } from '@mr-yum/frontend-ui'
import { DirectoryVenueCollectionsQuery } from 'lib/gql'
import filter from 'lodash/fp/filter'
import find from 'lodash/fp/find'
import flatten from 'lodash/fp/flatten'
import flow from 'lodash/fp/flow'
import map from 'lodash/fp/map'
import sortBy from 'lodash/fp/sortBy'
import uniqBy from 'lodash/fp/uniqBy'

export type DirectoryVC = NonNullable<
  DirectoryVenueCollectionsQuery['directoryVenueCollections'][0]
>
export type DirectoryVCVenues = NonNullable<
  DirectoryVC['venueCollectionToVenue']
>
export type DirectoryVCVenue = NonNullable<DirectoryVCVenues>[0] & {
  vcName: string
}

export const getOptions = (
  data: DirectoryVenueCollectionsQuery,
): SelectOption[] => {
  return map(
    ({ slug, name }: DirectoryVC): SelectOption => ({
      id: slug,
      label: name,
    }),
  )(data?.allCollections || [])
}

export const getCurrentOption = (options: SelectOption[], slug: string) =>
  find({ id: slug })(options)

export const getVcVenues = (
  data: DirectoryVenueCollectionsQuery,
): DirectoryVCVenue[] => {
  return flow(
    map(({ venueCollectionToVenue, ...venueCollection }: DirectoryVC) => ({
      ...venueCollection,
      venueCollectionToVenue: map(
        (venueCollectionToVenue: DirectoryVCVenues[0]): DirectoryVCVenue => ({
          vcName: venueCollection.name,
          ...venueCollectionToVenue,
        }),
      )(venueCollectionToVenue),
    })),
    map('venueCollectionToVenue'),
    flatten,
    filter({ enabled: true }),
    uniqBy('venue.id'),
    sortBy('venue.isClosed'),
  )(data?.directoryVenueCollections || [])
}
